import { each } from 'lodash';
import {
    action,
    observable,
    ObservableMap
} from 'mobx';

export interface ISection2DocumentSubmissionStore {
    /**
     * The most recently submitted document numbers, keyed by document id
     */
    lastSubmittedDocumentNumbers: ObservableMap<string, string>;

    /**
     * Stores the most recently submitted document numbers by document id
     * @param documentNumbersById
     */
    setLastSubmittedDocumentNumbers(documentNumbersById: Record<string, string>): void;
}

export class Section2DocumentSubmissionStore implements ISection2DocumentSubmissionStore {
    @observable
    lastSubmittedDocumentNumbers: ObservableMap<string, string> = new ObservableMap<string, string>();

    @action.bound
    setLastSubmittedDocumentNumbers(documentNumbersById: Record<string, string>) {
        this.lastSubmittedDocumentNumbers.clear();
        each(documentNumbersById, (value, key) => this.lastSubmittedDocumentNumbers.set(key, value));
    }
}



// WEBPACK FOOTER //
// ./src/stores/onboarding-review/section2-document-submission-store.ts